import checkIfWordPress from './checkIfWordPress';
import { isFramed } from './frameUtils';
import getLeadinConfig from './getLeadinConfig';
import showWarnings from './showWarnings';
function notifyLocationChange(location) {
  try {
    if (window.top) {
      window.top.postMessage(JSON.stringify({
        leadin_sync_route: location.pathname,
        leadin_sync_search: location.search
      }), '*');
    }
  } catch (e) {
    //
  }
}
export function setRaven(Raven) {
  const {
    leadinPluginVersion,
    phpVersion,
    wpVersion
  } = getLeadinConfig();
  try {
    if (checkIfWordPress()) {
      Raven.setTagsContext({
        v: leadinPluginVersion,
        php: phpVersion,
        wp: wpVersion
      });
    }
  } catch (e) {
    //
  }
}
export function setHistory(history) {
  try {
    if (checkIfWordPress()) {
      if (typeof history.listen === 'function') {
        history.listen(() => notifyLocationChange(window.location));
      } else if (typeof history.on === 'function') {
        history.on('route', () => notifyLocationChange(window.location));
      }
      notifyLocationChange(window.location);
    }
  } catch (e) {
    //
  }
}
export function getWindowHubSpotGlobal() {
  return window.hubspot || {};
}
export function setWordPressGlobal() {
  const windowHubSpot = getWindowHubSpotGlobal();
  if (typeof windowHubSpot.wordpress === 'undefined') {
    windowHubSpot.wordpress = isFramed() && !!getLeadinConfig().wpVersion;
  }
  window.hubspot = windowHubSpot;
  return windowHubSpot.wordpress;
}
export default function initWordPress(Raven, history, DEPRECATED_usageTracker, DEPRECATED_promiseStatus) {
  try {
    setWordPressGlobal();
    if (checkIfWordPress()) {
      const hsNav = document.getElementById('hs-nav-v4');
      if (hsNav) {
        hsNav.classList.add('wordpress-plugin-nav');
      } else if (Raven) {
        Raven.captureMessage('[ Wordpress-Plugin ] : could not append class to the HubSpot nav');
      }
      const style = document.createElement('style');
      const css = `#hs-nav-v4 { display: none; }
      .contacts > #hs-nav-v4~.app { height: 100vh !important; }`;
      style.appendChild(document.createTextNode(css));
      document.getElementsByTagName('head')[0].appendChild(style);
      if (Raven) {
        setRaven(Raven);
      }
      if (history) {
        setHistory(history);
      }
      showWarnings();
    }
  } catch (e) {
    //
  }
  return DEPRECATED_promiseStatus || Promise.resolve();
}